<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>财务报表</el-breadcrumb-item>
      <el-breadcrumb-item>分销退票</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card style="margin-top:20px">
      <span>暂时不做</span>
      <!-- <div class="titleStyle">
        <el-input placeholder="手机号" v-model="data.Mobile"></el-input>
        <el-input placeholder="订单号" v-model="data.OrderNumber"></el-input>
        <span class="datesSpan">日期：</span>
        <el-date-picker
          v-model="value1"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-select v-model="data.ScenicID" filterable placeholder="全部景区" clearable>
          <el-option
              v-for="item in options"
              :key="item.ScenicID"
              :label="item.Name"
              :value="item.ScenicID"
            ></el-option>
        </el-select>
        <el-select v-model="data.status" filterable placeholder="验票查询" clearable>
          <el-option
            v-for="item in option"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button @click="chaxun">查询</el-button>
        <el-button class="btnL" @click="exportList" >导出报表</el-button>
      </div>
      <div class="information">
        <div v-for="(item,index) in arr" :key="index" style="margin-top:2rem;">
            <div class="table_border">
              <div>
                <span>景区名称：</span>
                <span>{{ item.scenic_name }}</span>
              </div>
              <div class="borderight">
               
              <div>
                <span>订单号：</span>
                <span>{{ item.OrderNumber }}</span>
              </div>
              <div>
                <span>接受号码：</span>
                <span>{{ item.Mobile }}</span>
              </div>
              <div>
                <span>消费码：</span>
                <span>{{ item.OrderCode }}</span>
              </div>
              <div>
                <span>成交时间：</span>
                <span>{{ item.CreateTime }}</span>
              </div>
              <div>
                <span>订单总额：</span>
                <span>{{ item.ActFee }}</span>
              </div>
              <div @click="ticket(item)">
                <el-button>退票</el-button>
              </div>
              </div>
            </div>
            <el-table
              :data="item.order_detail"
              :header-cell-style="tableHeaderColor"
              :cell-style="cellStyle"
              style="width: 100%">
              <el-table-column prop="goods_name" label="产品名称" >
                <template slot-scope="scope">{{ scope.row.OrderAll.productname }}</template>
              </el-table-column>
              <el-table-column prop="ActPrice" label="代理价" >
              </el-table-column>
              <el-table-column prop="Count" label="购买数量" >
              </el-table-column>
              <el-table-column prop="UseTime" label="验票日期" >
                <template slot-scope="scope">
                  {{ scope.row.UseTime!=''?scope.row.UseTime:'暂无使用' }}
                </template>
              </el-table-column>
              <el-table-column prop="CountUse" label="已使用" >
              </el-table-column>
              <el-table-column  label="未使用" >
                <template slot-scope="scope">
                  {{ Number(scope.row.Count) - Number(scope.row.CountUse) - Number(scope.row.CancleCount) }}
                </template>
              </el-table-column>
              <el-table-column prop="CancleCount" label="退单" >
              </el-table-column>
              <el-table-column prop="num" label="可退数量">
                <template slot-scope="scope">
                  <div v-if="Number(scope.row.Count) - Number(scope.row.CountUse) - Number(scope.row.CancleCount)!=0">
                     <el-input v-model="scope.row.Stauts"></el-input>
                  </div>
                </template>
              </el-table-column>
            </el-table>  
        </div>
      </div>
      <div class="pagination">
        <span class="demonstration">共{{data.total}}条记录，</span>
        <span class="demonstration">当前显示第{{data.page}}页</span>
        <el-pagination background layout="prev, pager, next" :page-size="data.page_size" :total="data.total" :current-page="data.page"  @current-change="currenchange" ></el-pagination>
      </div> -->
    </el-card>
   
  </div>
</template>
<script>
import {getDistributorTwoOrderList,distributorTwoRefund,getDistributorTwoScenicList,distributorTwoPostExport} from '@/request/index.js'
  export default{
    data(){
      return{
        value:'',
        value1:'',
        options:[],
        option:[
          {
            value:'0',
            label:'未验票'
          },
          {
            value:'1',
            label:'验票'
          },
          {
            value:'1',
            label:'退票'
          }
        ],
        arr:[
        ],
        data:{
          token:window.sessionStorage.getItem('Token'),
          Mobile:'',
          OrderNumber:'',
          start_time:'',
          end_time:'',
          ScenicID:'',
          status:'',
          page:1,
          page_size:5,
          total:0
        }
      }
    },
    created(){
      this.getList()
      this.getScenList()
    },  
    methods:{
      exportList(){
        distributorTwoPostExport(this.data).then(res=>{
          console.log(res)
          if(res.data.status=='ok'){
            window.location.href = res.data.result
          }
        })
      },  
      chaxun(){
        this.data.total = 0
        this.data.page = 1
        if(this.value1){
          this.data.start_time = this.value1[0]
          this.data.end_time = this.value1[1]
        }else{
          this.data.start_time = ''
          this.data.end_time = ''
        }
        this.getList()
      },  
      getScenList(){
        let data= {
          token:window.sessionStorage.getItem('Token'),
          page:1,
          page_size:999
        }
        getDistributorTwoScenicList(data).then(res=>{
          if(res.data.status=='ok'){
            this.options = res.data.result
          }
        })
      },  
      currenchange(e){
        this.data.page = e
        this.getList()
      },  
      ticket(item){
        let orderdetailid = ''
        let ordernum = ''
        item.order_detail.map(itm=>{
            if(itm.Stauts>0){
              ordernum += itm.Stauts + ','
              orderdetailid += itm.OrderDetailID + ','
            }
        })
        if (orderdetailid.length > 0) {
          orderdetailid = orderdetailid.substr(0,orderdetailid.length - 1);
        }
        if (ordernum.length > 0) {
          ordernum = ordernum.substr(0,ordernum.length - 1);
        }
        let data = {
          token:window.sessionStorage.getItem('Token'),
          orderid:item.OrderID,
          orderdetailid:orderdetailid,
          ordernum:ordernum,
          distributor_id:item.DistributorID,
        }
        distributorTwoRefund(data).then(res=>{
          if(res.data.status=='ok'){
            this.$message.success('退票成功')
            this.getList()
          }
        })
      },
      getList(){
        getDistributorTwoOrderList(this.data).then(res=>{
          console.log(res)
          if(res.data.status=='ok'){
            this.arr = res.data.result.data
            this.data.total = res.data.result.total
          }
        })
      },
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        return this.utils.tableHeaderColor({
          row,
          column,
          rowIndex,
          columnIndex
        });
      },
      cellStyle({ row, rowIndex }) {
        return this.utils.cellStyle({
          row,
          rowIndex
        });
      }
    }
  }
</script>
<style lang="less" scoped>
.titleStyle {
  margin-bottom: 20px;
  .el-input {
    width: 220px;
    height: 40px;
    margin-right: 20px;
  }
  .el-select {
    width: 220px;
    margin-right: 20px;
  }
  .el-date-editor {
    width: 250px;
    margin-right: 20px;
  }
  .el-button {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    border: none;
    margin-right: 10px;
  }
  .btnL {
    width: 120px;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #246deb;
    color: #ffffff;
  }
}
.datesSpan{
  color: #666;
text-align: right;
font-size: 1.4rem;
}

.table_border{
  width: 100%;
  height: 50px;
  border: 1px solid #E5E5EA;
  background: #ffffff;
  display: flex;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  justify-content: space-between;
  >div{
    &:nth-child(1){
      span{
      color: #000;
      font-size: 1.4rem;
      &:nth-child(2){
        font-weight: 600;
      }
    }
    }
  }
}
.borderight{
  display: flex;
  align-items: center;
  >div{
    margin-right: 1.9rem;
    span{
      color: #000;
      font-size: 1.4rem;
      &:nth-child(2){
        font-weight: 600;
      }
    }
  }
}
.el-table{
  border-left: 1px solid #E5E5EA;
  border-right: 1px solid #E5E5EA;
  border-bottom: 1px solid #E5E5EA;
}
.pagination{
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>